import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  REPORTS_MENU,
  MR_REPORTS_LIST,
  MR_DOC_REPORT,
  PI_REPORTS_LIST,
  PI_DOC_REPORT,
  RFQ_REPORTS_LIST,
  RFQ_TO_PO_PENDING_REPORTS_LIST,
  RFQToPOPendingReport_DOC_REPORT,
  RFQ_DOC_REPORT,
  Q_REPORTS_LIST,
  Q_DOC_REPORT,
  CQ_REPORTS_LIST,
  CQ_DOC_REPORT,
  PO_REPORTS_LIST,
  PO_ITEM_REPORTS_LIST,
  PO_DOC_REPORT,
  IGP_REPORTS_LIST,
  IGP_REPORTS_PO_LIST,
  IGP_DOC_REPORT,
  MR_ITEMS_REPORTS_LIST,
  VENDOR_REPORTS_LIST,
  RFQ_PENDING_REPORTS_LIST,
  ITEM_WISE_REPORTS_LIST,
  UNIT_REPORTS_LIST,
  UNIT_DOC_REPORT,
  PO_AMENDAMENT_REPORTS_LIST,
  SR_DOC_REPORT,
  SR_RFQ_REPORTS_LIST,
  SR_RFQ_DOC_REPORT,
  SR_Q_DOC_REPORT,
  WO_DOC_REPORT,
  SR_REPORTS_LIST,
  SI_REPORTS_LIST,
  SI_DOC_REPORT,
  SR_CQ_REPORTS_LIST,
  SRQ_REPORTS_LIST,
  WO_REPORTS_LIST,
  REPORT_STATUS,
  DELAY_REPORTS_LIST,
  REPORT_DOWNLOAD,
  PO_REPORTS_LIST_FOR_DOCUMENT,
  PENDING_PO_DOC_REPORT,
  CONSUMPTION_DETAILED_DOC_REPORT,
  VENDOR_DUE_DETAILED_DOC_REPORT,
  MRTimeLine_DOC_REPORT,
  MRTimelLine_REPORTS_LIST,
  SRTimelLine_REPORTS_LIST,
  SRTimeLine_DOC_REPORT,
  GET_RFQ_VENDORS,
  SR_TIMELINE_CSV_EXPORT,
  MR_TIMELINE_CSV_EXPORT,
  PRODUCT_STOCK_REPORT_LIST,
  PRODUCT_STOCK_EXPORT_LIST,
} from "./actionTypes";
import {
  apiError,
  ReportsMenuSuccessful,
  MRreportslistSuccessful,
  MRDocReportSuccessful,
  PIreportslistSuccessful,
  PIDocReportSuccessful,
  RFQreportslistSuccessful,
  RFQToPOPendingReportslistSuccessful,
  RFQDocReportSuccessful,
  QreportslistSuccessful,
  QDocReportSuccessful,
  CQreportslistSuccessful,
  CQDocReportSuccessful,
  MRTimelLineDocReportSuccessful,
  POreportslistSuccessful,
  POItemreportslistSuccessful,
  PODocReportSuccessful,
  IGPreportslistSuccessful,
  IGPreportPOlistSuccessful,
  IGPDocReportSuccessful,
  MRItemsReportslistSuccessful,
  VendorReportslistSuccessful,
  RfqPendingReportslistSuccessful,
  ItemWiseReportslistSuccessful,
  UnitreportslistSuccessful,
  UnitDocReportSuccessful,
  POAmendamentReportslistSuccessful,
  SRDocReportSuccessful,
  SR_RFQDocReportSuccessful,
  RFQToPOPendingDocReportSuccessful,
  SR_RFQreportslistSuccessful,
  QDocSRReportSuccessful,
  WODocReportSuccessful,
  getWODocReport,
  SRreportslistSuccessful,
  SIreportslistSuccessful,
  SIDocReportSuccessful,
  SRCQreportslistSuccessful,
  SRQreportslistSuccessful,
  WOreportslistSuccessful,
  getPOreportslist,
  ReportStatus,
  DelayReportsList,
  reportDownloadSuccessful,
  reportDownload,
  POreportslistSuccessfulForDocument,
  getPendingPODocReport,
  PendingPODocReportSuccessful,
  ConsumpptionDetailSuccessful,
  vendorDueDetailSuccessful,
  MRTimelLinereportslistSuccessful,
  SRTimelLinereportslistSuccessful,
  SRTimelLineDocReportSuccessful,
  rfqVendorsSuccessful,
  SRTimelineCSVExportSuccessful,
  MRTimelineCSVExportSuccessful,
  ProductStockReportListSuccessful,
  ProductStockExportListSuccessful,
} from "./actions";

import {
  // postAdd,
  getList,
  getParamsList,
  postAdd,
  postDownloadFile,
  getDownloadFile,
  // getDownloadFile,
  // postEdit,
  // postDelete,
  // getRowData,
} from "../../helpers/Helper";
import Swal from "sweetalert2";

function* GetReportMenu() {
  try {
    const response = yield call(getList, "/system/usermenu/7", {});

    yield put(ReportsMenuSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetMRReportList({ payload: { data } }) {
  // Initialize params
  const params = {};

  // Validate data
  if (!data) {
    yield put(apiError(new Error("Payload data is undefined")));
    return;
  }

  // Build params
  Object.entries(data).forEach(([key, value]) => {
    if (key === "mrstatus") {
      // Handle mrstatus as number or array
      if (value != null && value !== 0) {
        params.mrstatus = Array.isArray(value)
          ? value.join(",")
          : String(value);
      }
    } else if (value !== "" && key !== "no_of_pages") {
      params[key] = value;
    }
  });
  try {
    const response = yield call(
      getParamsList,
      "/materialrequest/report",
      params
    );
    // console.log("Payload  response", response);

    yield put(MRreportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetSRReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "mrstatus") {
        if (data.mrstatus[0] !== 0) {
          params.mrstatus = data.mrstatus.join(",");
        }
      } else {
        if (data[k] !== "" && k !== "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/servicerequest/report",
      params
    );
    yield put(SRreportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetMRDocReport({ payload: { MRId } }) {
  try {
    const response = yield call(getList, "/materialrequest/report/" + MRId);

    yield put(MRDocReportSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetSRDocReport({ payload: { MRId } }) {
  // console.log("payload", MRId);
  try {
    const response = yield call(getList, "/servicerequest/report/" + MRId);

    yield put(SRDocReportSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetPIReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "pistatus") {
        if (data.pistatus[0] !== 0) {
          params.pistatus = data.pistatus.join(",");
        }
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/purchaseindent/report",
      params
    );
    yield put(PIreportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetSIReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "pistatus") {
        if (data.pistatus[0] !== 0) {
          params.pistatus = data.pistatus.join(",");
        }
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/serviceindent/report", params);
    yield put(SIreportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetPIDocReport({ payload: { PIId } }) {
  try {
    const response = yield call(getList, "/purchaseindent/report/" + PIId);

    yield put(PIDocReportSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetSIDocReport({ payload: { PIId } }) {
  try {
    const response = yield call(getList, "/serviceindent/report/" + PIId);

    yield put(SIDocReportSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetRFQReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "") {
        params[k] = data[k];
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/requestforquotation/report",
      params
    );
    yield put(RFQreportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetRFQToPOPendingReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "") {
        params[k] = data[k];
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/reports/rfqtopopendingreport/",
      params
    );
    yield put(RFQToPOPendingReportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetSRRFQReportList({ payload: { data } }) {
  // console.log("Hello World api");
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "") {
        params[k] = data[k];
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/servicerequestforquotation/report",
      params
    );
    yield put(SR_RFQreportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetSRRFQDocReport({ payload: { SR_RFQId, rfqPDF } }) {
  try {
    var response = {};
    if (rfqPDF) {
      response = yield call(getList, "/servicerequestforquotation/" + SR_RFQId);
    } else {
      response = yield call(
        getList,
        "/servicerequestforquotation/report/" + SR_RFQId
      );
    }

    yield put(SR_RFQDocReportSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetRFQToPOPendingReportDocReport({ payload: { RFQId, RFQToPOPendingpdf } }) {
  try {
    var response = {};
    if (RFQToPOPendingpdf) {
      response = yield call(getList, "/reports/rfqtopopendingreport/" + RFQId);
    } else {
      response = yield call(
        getList,
        "/reports/rfqtopopendingreport/" + RFQId
      );
    }

    yield put(RFQToPOPendingDocReportSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetRFQDocReport({ payload: { RFQId, rfqPDF } }) {
  try {
    var response = {};
    if (rfqPDF) {
      response = yield call(getList, "/requestforquotation/" + RFQId);
    } else {
      response = yield call(getList, "/requestforquotation/report/" + RFQId);
    }

    yield put(RFQDocReportSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetQReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "") {
        params[k] = data[k];
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/quotation/report", params);
    yield put(QreportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetSRQReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "") {
        params[k] = data[k];
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/servicequotation/report",
      params
    );
    yield put(SRQreportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetQDocReport({ payload: { QId, QuotationPdf } }) {
  try {
    var response = {};
    if (QuotationPdf) {
      response = yield call(getList, "/quotation/" + QId);
    } else {
      response = yield call(getList, "/quotation/report/" + QId);
    }

    yield put(QDocReportSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetSRQDocReport({ payload: { QId, QuotationPdf } }) {
  try {
    var response = {};
    if (QuotationPdf) {
      response = yield call(getList, "/servicequotation/" + QId);
    } else {
      response = yield call(getList, "/servicequotation/report/" + QId);
    }

    yield put(QDocSRReportSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetCQReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "") {
        params[k] = data[k];
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/comparequotation/report",
      params
    );
    yield put(CQreportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetSRCQReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "") {
        params[k] = data[k];
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/servicecomparequotation/report",
      params
    );
    yield put(SRCQreportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetMRTimeLineReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "") {
        params[k] = data[k];
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/reports/mrtimelinereport/",
      params
    );
    yield put(MRTimelLinereportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetCQDocReport({ payload: { CQId } }) {
  try {
    const response = yield call(getList, "/comparequotation/report/" + CQId);

    yield put(CQDocReportSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetMRTimelineDocReport({ payload: { id } }) {
  try {
    const response = yield call(getList, "/reports/mrtimelinedetailreport/" + id+'/');
    console.log("@Saga - GetMRTimelineDocReport: API Response:", "/reports/mrtimelinedetailreport/" + id);
    console.log(response,"MMMMMMMMMMMMMMMMMMMMMMMMMMM")

    yield put(MRTimelLineDocReportSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetPOReportListForDocument({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "") {
        params[k] = data[k];
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/purchaseorder/report", params);
    yield put(POreportslistSuccessfulForDocument(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
const delay = (ms) =>
  new Promise((resolve) => {
    setTimeout(() => {
      // here is where I want to specify my timeout logic
      resolve();
    }, ms);
  });

function* ReportDelay({ payload }) {
  // console.log("payload", payload);
  let timeout;
  timeout = yield delay(10000);
  yield put(ReportStatus({ request_id: payload.request_id }));
}
function* StatusReport({ payload }) {
  // console.log("Status Report", payload);
  try {
    var response = yield call(
      postAdd,
      "/reports/generic_export/status/" + payload.request_id + "/",
      {}
    );
    // console.log("Response", response);
    if (response.status === 201) {
      yield put(reportDownload({ request_id: payload.request_id }));
    } else if (response.status === 202) {
      yield put(DelayReportsList({ request_id: payload.request_id }));
    } else {
      Swal.fire({
        icon: "error",
        text: "Sorry! failed to generate the process report!",
      });
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      text: error,
    });
    yield put(apiError(error));
  }
}
function* DownloadReport({ payload }) {
  try {
    var response = yield call(
      postDownloadFile,
      "/reports/generic_export/download/" + payload.request_id + "/",
      {}
    );
    yield put(reportDownloadSuccessful(false));
    Swal.fire({
      icon: "success",
      text: "Your Report Generated Successfully.!",
    });
    yield put(reportDownloadSuccessful());
  } catch (error) {
    Swal.fire({
      icon: "error",
      text: "Sorry! Gettting from server side issue!",
    });
    // yield put(setActionTimeout());
    yield put(apiError(error));
  }
}

function* GetPOReportList({ payload }) {
  const { ParamsData, objData } = payload.data;
  const defaultParams = {
    page_size: 10,
    page: 1,
    search: "",
  };

  // Initialize params by merging defaultParams with ParamsData
  let params = { ...defaultParams };
  for (const k in ParamsData) {
    if (Object.hasOwnProperty.call(ParamsData, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = ParamsData.sortOrder + ParamsData.currentSort;
      } else {
        if (ParamsData[k] !== "" && k !== "no_of_pages") {
          params[k] = ParamsData[k];
        }
      }
    }
  }

  try {
    let response = yield call(
      postAdd,
      "/reports/generic_export/",
      objData,
      params
    );
    if (!response.status) {
      params.page = 1;
      response = yield call(
        postAdd,
        "/reports/generic_export/",
        objData,
        params
      );
      yield put(getPOreportslist({ objData: objData, ParamsData: params }));
    }
    if (response.status === 201) {
      yield put(
        ReportStatus({
          request_id: response.data.request_id,
        })
      );
    } else if (response.status === 200) {
      yield put(POreportslistSuccessful(response.data));
    } else {
      Swal.fire({
        icon: "error",
        text: "Sorry! Failed to generate the purchase order report!",
      });
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      text: error.message || "An error occurred",
    });
    yield put(apiError(error));
  }
}
function* GetWOReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "") {
        params[k] = data[k];
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/workorder/report", params);
    yield put(WOreportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetPOItemReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "") {
        params[k] = data[k];
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/reports/popendingitems/printdata",
      params
    );
    yield put(POItemreportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetPODocReport({ payload: { POId, POPdf } }) {
  try {
    var response = {};
    if (POPdf) {
      response = yield call(getList, "/purchaseorder/" + POId);
    } else {
      response = yield call(getList, "/purchaseorder/report/" + POId);
    }

    yield put(PODocReportSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetPendingPODocReport({ payload: { POId, POPdf } }) {
  try {
    var response = {};
    //     if (POPdf) {
    //       response = yield call(getList, "/purchaseorder/" + POId);
    //     } else {
    response = yield call(getList, "/purchaseorder/pendingpobyvendor/" + POId);
    //     }

    yield put(PendingPODocReportSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetConsumptionDetailedDocReport({ payload: { POId, POPdf } }) {
  try {
    var response = {};
    //     if (POPdf) {
    //       response = yield call(getList, "/purchaseorder/" + POId);
    //     } else {
    response = yield call(
      getList,
      "/purchaseorder/po-consumption/" + POId + "/"
    );
    //     }

    yield put(ConsumpptionDetailSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetVendorDueDocReport({ payload: { POId, POPdf } }) {
  try {
    var response = {};
    //     if (POPdf) {
    //       response = yield call(getList, "/purchaseorder/" + POId);
    //     } else {
    response = yield call(getList, "/purchaseorder/vendorduelist/" + POId);
    //     }

    yield put(vendorDueDetailSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetWODocReport({ payload: { WOId, POPdf } }) {
  try {
    var response = {};
    if (POPdf) {
      response = yield call(getList, "/workorder/" + WOId);
    } else {
      response = yield call(getList, "/workorder/report/" + WOId);
    }

    yield put(WODocReportSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetIGPReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "") {
        params[k] = data[k];
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/goodsreceivednote2/report",
      params
    );
    yield put(IGPreportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetIGPReportPOList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "") {
        params[k] = data[k];
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/goodsreceivednote2/report2",
      params
    );
    yield put(IGPreportPOlistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetIGPDocReport({ payload: { IGPId } }) {
  try {
    var response = {};

    response = yield call(getList, "/goodsreceivednote2/" + IGPId); // goodsreceivednote2/report/

    yield put(IGPDocReportSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetMRItemsReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "mrstatus") {
        if (data.mrstatus[0] !== 0) {
          params.mrstatus = data.mrstatus.join(",");
        }
      } else {
        if (data[k] !== "" && k !== "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/reports/mritemsstatus/",
      params
    );
    yield put(MRItemsReportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetVendorReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "mrstatus") {
        if (data.mrstatus[0] !== 0) {
          params.mrstatus = data.mrstatus.join(",");
        }
      } else {
        if (data[k] !== "" && k !== "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/reports/venderlist/", params);
    yield put(VendorReportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetRfqPendingReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "mrstatus") {
        if (data.mrstatus[0] !== 0) {
          params.mrstatus = data.mrstatus.join(",");
        }
      } else {
        if (data[k] !== "" && k !== "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/reports/rfqpendingitems/",
      params
    );
    yield put(RfqPendingReportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetItemWiseReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "mrstatus") {
        if (data.mrstatus[0] !== 0) {
          params.mrstatus = data.mrstatus.join(",");
        }
      } else {
        if (data[k] !== "" && k !== "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/reports/Itemlist/", params);
    yield put(ItemWiseReportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetUnitReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "") {
        params[k] = data[k];
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/goodsreceivednote2/unitwisereport",
      params
    );
    yield put(UnitreportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetUnitDocReport({ payload: { QId, UnitPdf } }) {
  try {
    var response = {};
    if (UnitPdf) {
      response = yield call(getList, "/goodsreceivednote/" + QId);
    } else {
      response = yield call(
        getList,
        "/goodsreceivednote2/unitwisereport" + QId
      );
    }

    yield put(UnitDocReportSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetPOAmendamentReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "") {
        params[k] = data[k];
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/reports/PurchaseOrderHistory/",
      params
    );
    yield put(POAmendamentReportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetSRTimelineReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "") {
        params[k] = data[k];
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/reports/srtimelinereport/",
      params
    );
    yield put(SRTimelLinereportslistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetSRTimelineDocReport({ payload: { id } }) {
  try {
    console.log("@Saga - GetSRTimelineDocReport: Calling API with SR Code:", id);
    const response = yield call(getList, `/reports/srtimelinedetailreport/${id}/`);
    console.log("KKKKKKKKKKKKKKKKKK", `/reports/srtimelinedetailreport/${id}/`)
    console.log("@Saga - GetSRTimelineDocReport: API Response:", response);

    yield put(SRTimelLineDocReportSuccessful(response));
  } catch (error) {
    console.error("@Saga - GetSRTimelineDocReport: API Error:", error);
    yield put(apiError(error));
  }
}

function* GetRFQVendors({ payload = {} }) {
  try {
    // payload should contain the rfq id
    const { rfq_id, ...params } = payload;
    const url = rfq_id ? `/reports/rfqvendors/${rfq_id}` : `/reports/rfqvendors/`;
    console.log('API Call - URL:', url, 'Params:', params, 'RFQ ID:', rfq_id);
    const response = yield call(getParamsList, url, params);
    console.log('API Response:', response);
    yield put(rfqVendorsSuccessful(response, payload));
  } catch (error) {
    console.error('API Error:', error);
    yield put(apiError(error));
  }
}

export function* watchReportMenu() {
  yield takeEvery(REPORTS_MENU, GetReportMenu);
}
export function* watchMRreportList() {
  yield takeEvery(MR_REPORTS_LIST, GetMRReportList);
}
export function* watchSRreportList() {
  yield takeEvery(SR_REPORTS_LIST, GetSRReportList);
}
export function* watchMRDocReport() {
  yield takeEvery(MR_DOC_REPORT, GetMRDocReport);
}
export function* watchSRDocReport() {
  yield takeEvery(SR_DOC_REPORT, GetSRDocReport);
}
export function* watchPIreportList() {
  yield takeEvery(PI_REPORTS_LIST, GetPIReportList);
}
export function* watchSIreportList() {
  yield takeEvery(SI_REPORTS_LIST, GetSIReportList);
}
export function* watchPIDocReport() {
  yield takeEvery(PI_DOC_REPORT, GetPIDocReport);
}
export function* watchSIDocReport() {
  yield takeEvery(SI_DOC_REPORT, GetSIDocReport);
}
export function* watchRFQreportList() {
  yield takeEvery(RFQ_REPORTS_LIST, GetRFQReportList);
}

export function* watchRFQToPOPendingreportList() {
  yield takeEvery(RFQ_TO_PO_PENDING_REPORTS_LIST, GetRFQToPOPendingReportList);
}
export function* watchSRRFQreportList() {
  yield takeEvery(SR_RFQ_REPORTS_LIST, GetSRRFQReportList);
}

export function* watchSRRFQDocReport() {
  yield takeEvery(SR_RFQ_DOC_REPORT, GetSRRFQDocReport);
}
export function* watchRFQToPOPendingDocReport() {
  yield takeEvery(RFQToPOPendingReport_DOC_REPORT, GetRFQToPOPendingReportDocReport);
}
export function* watchRFQDocReport() {
  yield takeEvery(RFQ_DOC_REPORT, GetRFQDocReport);
}
export function* watchQreportList() {
  yield takeEvery(Q_REPORTS_LIST, GetQReportList);
}
export function* watchSRQreportList() {
  yield takeEvery(SRQ_REPORTS_LIST, GetSRQReportList);
}
export function* watchQDocReport() {
  yield takeEvery(Q_DOC_REPORT, GetQDocReport);
}
export function* watchgetSRQDocReport() {
  yield takeEvery(SR_Q_DOC_REPORT, GetSRQDocReport);
}
export function* watchCQreportList() {
  yield takeEvery(CQ_REPORTS_LIST, GetCQReportList);
}
export function* watchSRCQreportList() {
  yield takeEvery(SR_CQ_REPORTS_LIST, GetSRCQReportList);
}

export function* watchMRTimeLinereportList() {
  yield takeEvery(MRTimelLine_REPORTS_LIST, GetMRTimeLineReportList);
}
export function* watchCQDocReport() {
  yield takeEvery(CQ_DOC_REPORT, GetCQDocReport);
}

export function* watchMRTimelineDocReport() {
  yield takeEvery(MRTimeLine_DOC_REPORT, GetMRTimelineDocReport);
}
export function* watchPOreportList() {
  yield takeEvery(PO_REPORTS_LIST, GetPOReportList);
}
export function* watchPOreportListForDocument() {
  yield takeEvery(PO_REPORTS_LIST_FOR_DOCUMENT, GetPOReportListForDocument);
}
export function* watchReportStatus() {
  yield takeEvery(REPORT_STATUS, StatusReport);
}
export function* watchWOreportList() {
  yield takeEvery(WO_REPORTS_LIST, GetWOReportList);
}
export function* watchPOItemreportList() {
  yield takeEvery(PO_ITEM_REPORTS_LIST, GetPOItemReportList);
}
export function* watchPODocReport() {
  yield takeEvery(PO_DOC_REPORT, GetPODocReport);
}
export function* watchGetWODocReport() {
  yield takeEvery(WO_DOC_REPORT, GetWODocReport);
}
export function* watchIGPreportList() {
  yield takeEvery(IGP_REPORTS_LIST, GetIGPReportList);
}
export function* watchIGPreportPOList() {
  yield takeEvery(IGP_REPORTS_PO_LIST, GetIGPReportPOList);
}
export function* watchIGPDocReport() {
  yield takeEvery(IGP_DOC_REPORT, GetIGPDocReport);
}
export function* watchMRItemsReportList() {
  yield takeEvery(MR_ITEMS_REPORTS_LIST, GetMRItemsReportList);
}
export function* watchVendorReportList() {
  yield takeEvery(VENDOR_REPORTS_LIST, GetVendorReportList);
}
export function* watchRfqPendingReportList() {
  yield takeEvery(RFQ_PENDING_REPORTS_LIST, GetRfqPendingReportList);
}
export function* watchItemWiseReportList() {
  yield takeEvery(ITEM_WISE_REPORTS_LIST, GetItemWiseReportList);
}
export function* watchUnitreportList() {
  yield takeEvery(UNIT_REPORTS_LIST, GetUnitReportList);
}
export function* watchUnitDocReport() {
  yield takeEvery(UNIT_DOC_REPORT, GetUnitDocReport);
}
export function* watchPOAmendamentReport() {
  yield takeEvery(PO_AMENDAMENT_REPORTS_LIST, GetPOAmendamentReportList);
}
export function* watchReportDownload() {
  yield takeEvery(REPORT_DOWNLOAD, DownloadReport);
}
export function* watchDelayReportsList() {
  yield takeEvery(DELAY_REPORTS_LIST, ReportDelay);
}
export function* watchPendingPODocReport() {
  yield takeEvery(PENDING_PO_DOC_REPORT, GetPendingPODocReport);
}
export function* watchConsumptioDetailedDocReport() {
  yield takeEvery(
    CONSUMPTION_DETAILED_DOC_REPORT,
    GetConsumptionDetailedDocReport
  );
}
export function* watchVendorDueDetailedDocReport() {
  yield takeEvery(VENDOR_DUE_DETAILED_DOC_REPORT, GetVendorDueDocReport);
}

export function* watchSRTimeLinereportList() {
  yield takeEvery(SRTimelLine_REPORTS_LIST, GetSRTimelineReportList);
}


export function* watchSRTimelineDocReport() {
  yield takeEvery(SRTimeLine_DOC_REPORT, GetSRTimelineDocReport);
}

function* GetSRTimelineCSVExport({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "") {
        params[k] = data[k];
      }
    }
  }
  try {
    const url = `/reports/srtimelineexport/?${new URLSearchParams(params).toString()}`;
    yield call(getDownloadFile, url);
    yield put(SRTimelineCSVExportSuccessful({}));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetMRTimelineCSVExport({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "") {
        params[k] = data[k];
      }
    }
  }
  try {
    const url = `/reports/mrtimelineexport/?${new URLSearchParams(params).toString()}`;
    yield call(getDownloadFile, url);
    yield put(MRTimelineCSVExportSuccessful({}));
  } catch (error) {
    yield put(apiError(error));
  }
}

export function* watchGetRFQVendors() {
  yield takeEvery(GET_RFQ_VENDORS, GetRFQVendors);
}

export function* watchSRTimelineCSVExport() {
  yield takeEvery(SR_TIMELINE_CSV_EXPORT, GetSRTimelineCSVExport);
}

export function* watchMRTimelineCSVExport() {
  yield takeEvery(MR_TIMELINE_CSV_EXPORT, GetMRTimelineCSVExport);
}

function* GetProductStockReportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "" && data[k] !== null && data[k] !== undefined) {
        params[k] = data[k];
      }
    }
  }
  // ensure pagination params are always sent
  if (!params.page) params.page = 1;
  if (!params.page_size) params.page_size = 50;
  try {
    const response = yield call(
      getParamsList,
      "/reports/productstockreport/",
      params
    );
    yield put(ProductStockReportListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

export function* watchProductStockReportList() {
  yield takeEvery(PRODUCT_STOCK_REPORT_LIST, GetProductStockReportList);
}

function* GetProductStockExportList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (data[k] !== "" && data[k] !== null && data[k] !== undefined) {
        params[k] = data[k];
      }
    }
  }
  // fetch all records — no pagination limit
  params.page = 1;
  params.page_size = 99999;
  try {
    const response = yield call(
      getParamsList,
      "/reports/productstockreport/",
      params
    );
    yield put(ProductStockExportListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

export function* watchProductStockExportList() {
  yield takeEvery(PRODUCT_STOCK_EXPORT_LIST, GetProductStockExportList);
}

function* reportSaga() {
  yield all([
    fork(watchReportMenu),
    fork(watchMRreportList),
    fork(watchSRreportList),
    fork(watchMRDocReport),
    fork(watchSRDocReport),
    fork(watchPIreportList),
    fork(watchSIreportList),
    fork(watchPIDocReport),
    fork(watchSIDocReport),
    fork(watchRFQreportList),
    fork(watchRFQToPOPendingreportList),
    fork(watchSRRFQreportList),
    fork(watchRFQDocReport),
    fork(watchSRRFQDocReport),
    fork(watchRFQToPOPendingDocReport),
    fork(watchQreportList),
    fork(watchSRQreportList),
    fork(watchQDocReport),
    fork(watchgetSRQDocReport),
    fork(watchCQreportList),
    fork(watchSRCQreportList),
    fork(watchCQDocReport),
    fork(watchPOreportList),
    fork(watchWOreportList),
    fork(watchPOItemreportList),
    fork(watchPODocReport),
    fork(watchGetWODocReport),
    fork(watchIGPreportList),
    fork(watchIGPreportPOList),
    fork(watchIGPDocReport),
    fork(watchMRItemsReportList),
    fork(watchVendorReportList),
    fork(watchRfqPendingReportList),
    fork(watchItemWiseReportList),
    fork(watchUnitreportList),
    fork(watchUnitDocReport),
    fork(watchPOAmendamentReport),
    fork(watchDelayReportsList),
    fork(watchReportStatus),
    fork(watchReportDownload),
    fork(watchPOreportListForDocument),
    fork(watchPendingPODocReport),
    fork(watchConsumptioDetailedDocReport),
    fork(watchVendorDueDetailedDocReport),
    fork(watchMRTimelineDocReport),
    fork(watchMRTimeLinereportList),
    fork(watchSRTimelineDocReport),
    fork(watchSRTimeLinereportList),
    fork(watchGetRFQVendors),
    fork(watchSRTimelineCSVExport),
    fork(watchMRTimelineCSVExport),
    fork(watchProductStockReportList),
    fork(watchProductStockExportList),
  ]);
}

export default reportSaga;
